import Vue from 'vue';
import VueRouter from 'vue-router';
import Vuetify from './vuetify';
import IdleVue from 'idle-vue';
import Vuex from 'vuex';
import AppAdmin from '../components/application/AppAdmin.vue';
import {ValidationProvider, ValidationObserver} from 'vee-validate/dist/vee-validate.full';
import BugSnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import {Routes} from './routes';
import mixins from '../mixins';
import store from '../store-admin';
import VueShortKey from 'vue-shortkey';
import retryRequest from "../retryRequest";
import 'vue-json-pretty/lib/styles.css'

// In build BUGSNAG key will be null
if (process.env.BUGSNAG_VUE_KEY) {

    /** Create global instance of bugsnag client **/
    BugSnag.start({
        apiKey: process.env.BUGSNAG_VUE_KEY,
        enabledReleaseStages: ['production', 'staging'],
        releaseStage: process.env.NODE_ENV,
        plugins: [new BugsnagPluginVue(Vue)],
        appVersion: process.env.BUILD
    });
}

/** Create global instance of axios **/
window.axios = require('axios');

/**
 * Set CSRF token automatically based on what is printed on the index.php page
 */

window.axios.defaults.headers.common = {
    'X-Requested-With': 'XMLHttpRequest',
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
};

/**
 * Intercept the incoming responses.
 *
 * Handle any unexpected HTTP errors and pop up modals, etc.
 */
window.axios.interceptors.response.use(function (response) {
    return response;
}, async function (error) {
    switch (error.response.status) {
        case 401:

            // Log user out
            await window.axios.get('/logout');

            // Send event
            Bus.$emit('show-session-expired');
            break;

        case 402:
            Bus.$emit('show-trial-expired');
            break;

        case 419:

            const retriedResponse = retryRequest(error.config);

            if (retriedResponse) {
                return retriedResponse;
            }

            break;

        case 429:
            Bus.$emit('flash-message', {
                message: 'Too many requests! Please wait before trying again.',
                type: 'error',
                duration: 8000
            });
            break;

        case 500:
            Bus.$emit('flash-message', {
                message: 'Oops! Something went wrong on our side. Please try again later.',
                type: 'error',
                duration: 8000
            });
            break;
    }

    return Promise.reject(error);
});

// Add global pusher object
window.Pusher = require('pusher-js');

// Create Bus for communications
window.Bus = new Vue();

// Global components
Vue.component('AppAdmin', AppAdmin);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

// Global mixins
Vue.mixin(mixins);

// Plugins
Vue.use(VueShortKey);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(IdleVue, {
    eventEmitter: new Vue(),
    idleTime: 120 * 1000
});

Vue.config.productionTip = false;

new Vue({
    vuetify: Vuetify,
    router: new VueRouter({
        mode: 'history',
        routes: Routes
    }),
    store: new Vuex.Store(store)
}).$mount('#app');
